export default __webpack_public_path__ + "static/media/icon_economie.8cf5175c.png";